import { render, staticRenderFns } from "./software-workflow.vue?vue&type=template&id=27d49470&"
import script from "./software-workflow.vue?vue&type=script&lang=js&"
export * from "./software-workflow.vue?vue&type=script&lang=js&"
import style0 from "./software-workflow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports